import { useEffect } from "react";
import { GATEWAYS } from "@/lib/gateways";
import useSEO from "@/hooks/useSEO";

/**
 * Client-side redirect that sends visitors straight to the correct
 * external app store URL for a given gateway + store.
 *
 * Usage: <StoreRedirect gatewayId="selah-downloads" store="Apple" />
 */
export default function StoreRedirect({ gatewayId, store }) {
  // Prevent search engines from indexing these redirect stubs.
  useSEO({
    title: "Redirecting… — Selah and Stone Legacy Holdings",
    description: "Redirecting to the app store.",
    path: `/downloads/${store.toLowerCase()}`,
    noindex: true,
  });

  useEffect(() => {
    const gateway = GATEWAYS.find((g) => g.id === gatewayId);
    const target = gateway?.platforms?.find(
      (p) => p.name.toLowerCase() === store.toLowerCase() && p.href,
    );
    // If we have a match, hand off to the store. Otherwise send the visitor
    // back to the Downloads gateway on the landing page.
    const href = target?.href || `/#${gatewayId}`;
    window.location.replace(href);
  }, [gatewayId, store]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F5E8E0",
        color: "#556B2F",
        fontFamily: "Montserrat, sans-serif",
        letterSpacing: "0.36em",
        textTransform: "uppercase",
        fontSize: "12px",
      }}
      data-testid={`store-redirect-${gatewayId}-${store.toLowerCase()}`}
    >
      Redirecting to the {store} store…
    </div>
  );
}
